import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BsHeartFill, BsFillChatFill } from "react-icons/bs";

function PostsList() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await fetch(
          "https://dev.to/api/articles?username=sarahcssiqueira"
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setArticles(data);
      } catch (error) {
        console.error("Error fetching articles:", error);
      }
    };

    fetchArticles();
  }, []);

  return (
    <section className="grid font-sans text-slate-800">
      {articles.map((article) => {
        return (
          <article key={article.id} className="grid_item bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden">
            <Link
              to={`../post/${article.slug}/${article.id}`}
              className="grid_item_title"
            >
              <img
                src={article.cover_image}
                alt={article.title}
                className="grid_item_img"
              />
            </Link>

            <Link
              to={`../post/${article.slug}/${article.id}`}
              className="text-base font-bold text-slate-800 hover:text-purple-700 transition-colors leading-snug"
            >
              {article.title}
            </Link>

            <ul className="grid_item_tags text-sm text-slate-500">
              <li className="grid_item_tags_date">
                {article.readable_publish_date}
              </li>
              <li className="grid_item_tags_date">
                {article.reading_time_minutes} min read
              </li>
              <li className="grid_item_tags_date flex items-center gap-1">
                {article.public_reactions_count} <BsHeartFill className="text-purple-400" />
              </li>
              <li className="grid_item_tags_date flex items-center gap-1">
                {article.comments_count} <BsFillChatFill className="text-purple-400" />
              </li>
            </ul>

                            
            <ul className="flex flex-wrap gap-2 text-sm font-light">
              {article.tags.split(",").map((tag, i) => (
                <li
                  key={i}
                  className="bg-purple-50 text-purple-700 px-2 py-0.5 rounded"
                >
                  #{tag.trim()}
                </li>
              ))}
            </ul>
          </article>
        );
      })}
    </section>
  );
}

export default PostsList;
